import StatusBanner from '~/components/scales/StatusBanner/StatusBanner';

export default function UploadError(props: { label?: string; description?: string | string[] }) {
  return (
    <div className="w-full text-left">
      <StatusBanner data-cy="import-error-banner" type="error">
        <div className="flex flex-col">
          <strong>{props.label}</strong>
          {Array.isArray(props.description)
            ? props.description.map((text) => (
                <div key={text} className="type-body2">
                  {text}
                </div>
              ))
            : props.description}
        </div>
      </StatusBanner>
    </div>
  );
}
